<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="8">
        <ITListEmployee />
      </v-col>
      <v-col cols="12" sm="12" md="8" lg="4"> <ITList /> </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ITListEmployee from './components/ITListEmployee'
import ITList from './components/ITList'

export default {
  name: 'IncomeTax',
  components: { ITListEmployee, ITList },
  data: () => {
    return {}
  },
}
</script>
